
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CommissionService from "@/services/auth/CommissionService";
import LineChart from "@/components/LineChart.vue";
import UserService from "@/services/auth/UserService";
import diaUtil from '@lfreneda/eh-dia-util';
import ReportService from "@/services/reportService";

@Component({
  components: { LineChart }
})
export default class OnlineAttendantsList extends Vue {
  @Prop()
  private firstDate;

  @Prop()
  private lastDate;

  @Prop()
  private action;

  @Prop()
  private loadingMetric;

  @Prop()
  private costValues;

  @Watch("loadingMetric", { immediate: false, deep: false })
  onLoadingMetricChanged(val: any, oldVal: any) {

    if (this.costValues)
        this.getCostValue(
            this.$moment(new Date(this.firstDate)).format("YYYY-MM-DD"),
            this.$moment(new Date(this.lastDate)).format("YYYY-MM-DD")
        );
    else
        this.getCommissionList(
            this.$moment(new Date(this.firstDate)).format("YYYY-MM-DD"),
            this.$moment(new Date(this.lastDate)).format("YYYY-MM-DD")
        );
  }

  private accumulatedCheckbox:boolean = false;
  private CommissionServiceInstance = new CommissionService();
  private chartLoading = false;
  private loading = false;
  private commissionList: any = [];
  private commissionGoal: any = [];
  private graphicCostValues:any = [];
  private monthlyGoalGraphic: Array<Object> = [];
  private historyCommissionGraphic: Array<Object> = [];
  private valuesgraphicCostValues: Array<Object> = [];
  private height = 270;
  private self = this;

  private get chartStyles() {
    return {
      height: `${this.height}px`,
      width: "100%",
      position: "relative"
    };
  }

  private get getCostValues() {
      return !this.valuesgraphicCostValues.length
  }

  private optChart = {
    title: {
      display: false,
      text: `${this.self.costValues ? 'Custo de mensagem' : "Meu histórico de comissões"}`
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          type: "time",
          time: {
            unit: "day",
            parser: "YYYY-MM-DD",
            tooltipFormat: "DD/MM/YYYY",
            displayFormats: {
              day: "DD/MM"
            }
          },
          gridLines: {
            drawOnChartArea: false,
            color: "gray",
            drawTicks: false,
            lineWidth: 2,
            z: 1
          },
          ticks: {
            display: true,
            padding: 5,
            minRotation: 30,
            maxRotation: 30
          },
          stacked: true,
          maxBarThickness: 30
        }
      ],
      yAxes: [
        {
          id: 0,
          type: "linear",
          position: "left",
          ticks: {
            display: true,
            beginAtZero: true,
            padding: 5
          },
          gridLines: {
            drawOnChartArea: false,
            color: "#172542",
            drawTicks: false,
            lineWidth: 2,
            z: 1,
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: `${this.self.costValues ? "Valor Gasto" : "Comissão"}`
          }
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].label || "";
          if (label) label += ": ";
          label += `R$ ${parseFloat(tooltipItem.yLabel).toLocaleString(
            "pt-br",
            { minimumFractionDigits: 2 }
          )}`;
          return label;
        }
      }
    },
    legend: {
      display: false,
      position: "bottom"
    }
  };

  private dataChart = {
    datasets: [
      {
        label: "Comissão",
        yAxisID: 0,
        backgroundColor: "#b499e3bf ",
        pointBackgroundColor: "#172542",
        borderColor: "#172542",
        data: [] as any,
        fill: true,
        spanGaps: true
      },
      {
        label: "Objetivo pessoal",
        yAxisID: 0,
        backgroundColor: "#b499e3bf ",
        pointBackgroundColor: "#e50e0c",
        borderColor: "#e50e0c",
        data: [] as any,
        fill: true,
        spanGaps: true
      }
    ]
  };

  private async getCommissionList(firstDate: any, lastDate: any) {
    this.chartLoading = true;

    if(this.$moment(new Date(firstDate)).diff(lastDate, 'days') >= 0)  {
        firstDate = this.$moment().startOf('month').format('YYYY-MM-DD');
        lastDate = this.$moment().endOf('month').format('YYYY-MM-DD')
    }

    await this.CommissionServiceInstance.commissionList(firstDate, lastDate)
        .then( async (result: any) => {
            const userService = new UserService();
            const response = await userService.getUserMyData();

            this.monthlyGoalGraphic = [];
            this.historyCommissionGraphic = [];
            this.commissionGoal = response.body;

            let monthWorkinDay:any = [];
            let auxDate = (<any>this.$moment(firstDate));

            while (auxDate.isBefore((<any>this.$moment(lastDate)))) {
                monthWorkinDay[(<any>this.$moment(auxDate)).format('MM')] = 0;
                monthWorkinDay[(<any>this.$moment(lastDate)).format('MM')] = 0;
                auxDate.add(1, 'month')
            }

            for (let month of Object.keys(monthWorkinDay)) {

                let workinDay = 0;
                let currentDay:any = (<any>this.$moment()).set({'month': parseInt(month) - 1}).startOf('month')
                while (currentDay.isBefore((<any>this.$moment()).set({'month': parseInt(month) - 1}).endOf('month'))) {
                    if (diaUtil(currentDay.format('YYYY-MM-DD')))
                        workinDay++;

                    currentDay = currentDay.add(1, 'd');
                }

                monthWorkinDay[month] = this.commissionGoal.goal / workinDay;
            }

            if (this.commissionGoal && result.commission )  {
                let currentDay:any = this.$moment(firstDate);
                while (currentDay.diff(this.$moment(lastDate), 'days') <= 0 ) {
                    if(!result.commission[currentDay.format('YYYY-MM-DD')] || currentDay.diff(this.$moment(), 'days') >= 0 )
                        result.commission[currentDay.format('YYYY-MM-DD')] = 0;

                    currentDay = currentDay.add(1, 'd');
                }
            }

            if(this.accumulatedCheckbox)  {

                let accumulatedValues = 0;
                const values:any = Object.values(result.commission);
                let aux = 0;
                let index = 0;
                for (const key of Object.keys(result.commission).sort()) {
                    aux = accumulatedValues;
                    accumulatedValues += monthWorkinDay[this.$moment(key).format('MM')];
                    if(values[index] === 0)
                        continue;

                    values[index] = values[index - 1] ? values[index - 1] + values[index] : values[index];
                    this.historyCommissionGraphic.push({ t: key, y: values[index] });
                    if (this.$moment(JSON.stringify(key)).day() !== 0 && this.$moment(JSON.stringify(key[index])).day() !== 6)  {
                        this.monthlyGoalGraphic.push({ t: key, y: (accumulatedValues).toFixed(2) });
                    }else{
                        this.monthlyGoalGraphic.push({ t: key, y: (aux).toFixed(2) });
                    }

                    index++;
                }

            }else{

                if (result && result.commission) {
                    for (const key of Object.keys(result.commission).sort()) {
                        const element = result.commission[key];
                        const day  = this.$moment(JSON.stringify(key));
                        if(element === 0)
                            continue;

                        this.historyCommissionGraphic.push({ t: key, y: element.toFixed(2) });
                        if (diaUtil(day.format('YYYY-MM-DD')))  {
                            this.monthlyGoalGraphic.push({ t: key, y: monthWorkinDay[this.$moment(key).format('MM')].toFixed(2) });
                        }else{
                            this.monthlyGoalGraphic.push({ t: key, y: 0 });
                        }
                    }
                }

            }

            this.commissionList = result;

            if (result && result.hideCommission !== undefined) {
                this.$store.commit("commission/HIDE_COMMISSION", result.hideCommission);
            } else {
                this.$store.commit("commission/HIDE_COMMISSION", false);
            }

            this.dataChart.datasets[0].data = this.historyCommissionGraphic;
            this.dataChart.datasets[1].data = this.monthlyGoalGraphic;
            this.chartLoading = false;
        }
    );
  }

  private accumulatedValues()  {
    this.loading = true;

    this.loadingMetric = true;

    this.getCommissionList(
        this.$moment(new Date(this.firstDate)).format("YYYY-MM-DD"),
        this.$moment(new Date(this.lastDate)).format("YYYY-MM-DD")
    );

    this.dataChart.datasets[0].data = this.historyCommissionGraphic;
    this.dataChart.datasets[1].data = this.monthlyGoalGraphic;
    this.loadingMetric = false;
    this.loading = false;
  }

  private async getCostValue(firstDate: any, lastDate: any) {
    this.chartLoading = true;

    const reportservice = new ReportService();
    let filterDate: Array<any> = ["", ""];
    if (!firstDate)
      firstDate = (this.$moment(this.firstDate) as any).format("YYYY-MM-DD");

    if (!lastDate)
      lastDate = (this.$moment(this.lastDate) as any).format("YYYY-MM-DD");

    this.graphicCostValues = await reportservice.getCostValue(firstDate, lastDate, this.$auth.user().id_platform);

    this.valuesgraphicCostValues = [];
    if(typeof this.graphicCostValues != 'string')
        for (const key of Object.keys(this.graphicCostValues.expenditures).sort()) {
            this.valuesgraphicCostValues.push({ t: key, y: this.graphicCostValues.expenditures[key] * 5 });
        }

    this.dataChart.datasets[0].data =  this.valuesgraphicCostValues;
    this.chartLoading = false;
    this.loadingMetric = false;
    this.$emit('resetarloadingMetric', false);
  }

  private created() {
    if(this.costValues)  {
        this.getCostValue(
          this.$moment().startOf('month').format('YYYY-MM-DD'),
          this.$moment().endOf('month').format('YYYY-MM-DD')
        );
    }else{
        this.getCommissionList(
          this.$moment().startOf('month').format('YYYY-MM-DD'),
          this.$moment().endOf('month').format('YYYY-MM-DD')
        );
    }

  }
}
